import axiosIns from '@/plugins/axios'
import {
  ApiList, ApiDetail, JsonApiResource, JsonApiSingleResponse,
} from '@/api/v2/types/json-api'

export interface UserAttrs {
  id: number
  name: string
  role: string
}
export interface AggregationUserAttrs {
  id: number
  aggregationId: string
  userId: string
  user: JsonApiSingleResponse<JsonApiResource<string, UserAttrs>>
}

export type AggregationUserListResponse = ApiList<AggregationUserAttrs, 'aggregationUser'>
export type AggregationUserSingleResponse = ApiDetail<AggregationUserAttrs, 'aggregationUser'>

export async function fetchAggregationUsers(aggregationContainerId: number, aggregationId: number): Promise<AggregationUserAttrs[]> {
  const res = await axiosIns.get<AggregationUserListResponse>(
    `/v2/report/aggregation_containers/${aggregationContainerId}/aggregations/${aggregationId}/aggregation_users`,
  )

  return res.data.data.data.map(r => r.attributes)
}

export async function createAggregationUser(aggregationContainerId: number, aggregationId: number, userId: number): Promise<AggregationUserAttrs> {
  const res = await axiosIns.post<AggregationUserSingleResponse>(
    `/v2/report/aggregation_containers/${aggregationContainerId}/aggregations/${aggregationId}/aggregation_users`,
    { user_id: userId },
  )

  return res.data.data.data.attributes
}

export async function destroyAggregationUser(aggregationContainerId: number, aggregationId: number, aggregationUserId: number): Promise<AggregationUserAttrs> {
  const res = await axiosIns.delete<AggregationUserSingleResponse>(
    `/v2/report/aggregation_containers/${aggregationContainerId}/aggregations/${aggregationId}/aggregation_users/${aggregationUserId}`,
  )

  return res.data.data.data.attributes
}
